module.exports = __webpack_public_path__ + "static/media/Zoom-in.a835230f.png";